import { lazyView } from '../platform/index.ts';

export {
  AccountsError,
  EVERY_PROJECT,
  SignInError,
  connectedTools,
  safeReturn,
  sendPasswordResetLink,
  type ConnectedTool,
} from './accounts.ts';
export {
  CANCEL_BTN,
  CARD,
  CARD_HEAD,
  DANGER_BTN,
  ErrorBanner,
  INPUT,
  Loading,
  Modal,
  PAGE,
  PRIMARY_BTN,
  PageHeader,
  RoleBadge,
  SELECT,
  SMALL_BTN,
  SUBMIT_BTN,
  errorMessage,
  formatDate,
  unwrap,
} from './admin/common.tsx';
export {
  ORG_ROLES,
  SCOPES,
  SHARE_ROLES,
  type ApiToken,
  type CreatedApiToken,
  type Entitlements,
  type Invitation,
  type Member,
  type Org,
  type OrgRole,
  type Project,
  type Scope,
  type ShareList,
  type ShareRole,
  type TokenScope,
} from './admin/types.ts';
export {
  AuthProvider,
  displayName,
  isAppUserOnly,
  shellRoles,
  useAuth,
  type Capabilities,
  type Reconnect,
} from './auth.tsx';
export { BOARD_CHANGED_EVENT, BadgesProvider, badgeLabel, useBadges } from './badges.tsx';
export { ForgotPasswordPage } from './pages/ForgotPassword.tsx';
export { InviteAcceptPage } from './pages/InviteAccept.tsx';
export { LoginPage } from './pages/Login.tsx';
export { MfaVerificationPage } from './pages/MfaVerification.tsx';
export { ResetPasswordPage } from './pages/ResetPassword.tsx';
export { SignUpPage } from './pages/SignUp.tsx';
export { VerifyEmailPage } from './pages/VerifyEmail.tsx';
export { roleLabel } from './roles.ts';
export {
  ensureRuntimeSession,
  keepRuntimeSession,
  runtimeBase,
  runtimeSession,
  warmRuntimeSession,
} from './runtime-session.ts';

/** Its pages and views the host (or another module) loads when shown. */
export const pages = {
  AuditLog: () => import('./AuditLog.tsx'),
  'admin/Profile': () => import('./admin/Profile.tsx'),
};

/** Its settings cards (the workspace's settings pages show them), loaded when shown. */
export const AuditRetentionCard = lazyView(
  async () => (await import('./admin/AuditRetentionCard.tsx')).AuditRetentionCard,
);
export const IdentityCard = lazyView(async () => (await import('./admin/IdentityCard.tsx')).IdentityCard);
export const MfaPolicyCard = lazyView(async () => (await import('./admin/MfaPolicyCard.tsx')).MfaPolicyCard);
export const PermissionsMatrix = lazyView(
  async () => (await import('./admin/PermissionsMatrix.tsx')).PermissionsMatrix,
);
